export default "__VITE_ASSET__mTcbGZQe__"